import React from 'react'
import styled from '@emotion/styled'
import { colors, severityColors } from 'style/theme'
import { ShowStyledItems } from 'components'
import SelectorColumn from '../../Scan/components/SelectorColumn';

const MoreCountNoBorder = styled.div(({ color }) => ({
	height: 30,
	width: '100%',
	lineHeight: '28px',
	color: color,
	fontSize: '0.9rem'
}))

const DocumentError = styled.div({
	fontWeight: "bold"
})

export default [
	{
		title: 'SELECTORS',
		dataIndex: 'selector',
		width: '70%',
		render: (selector) => {
			selector = selector ? selector : (<DocumentError>#document</DocumentError>)
			return (
				<SelectorColumn selector={selector} />
			)
		}
	},
	{
		title: 'REGRESSION',
		dataIndex: 'regressions',
		align: 'center',
		render(regressions) {
			let errCodes = regressions.map((item) => {
				item.color = severityColors[item.severity.toLowerCase()];
				return item;
			})
			return (
				<ShowStyledItems
					count={1}
					moreItems={errCodes}
					renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{count}</MoreCountNoBorder>}
				/>
			)
			
		}
	},
	{
		title: 'FIXED',
		dataIndex: 'fixed',
		align: 'center',
		render(fixed) {
			let errCodes = fixed.map((item) => {
				item.color = severityColors[item.severity.toLowerCase()];
				return item;
			})
			return (
				<ShowStyledItems
					count={1}
					moreItems={errCodes}
					renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{count}</MoreCountNoBorder>}
				/>
			)
			
		}
	},
	{
		title: 'NO CHANGE',
		dataIndex: 'no_change',
		align: 'center',
		render(noChange) {
			let errCodes = noChange.map((item) => {
				item.color = severityColors[item.severity.toLowerCase()];
				return item;
			})
			return (
				<ShowStyledItems
					count={1}
					moreItems={errCodes}
					renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{count}</MoreCountNoBorder>}
				/>
			)
			
		}
	}
]

